import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfigContext } from 'src/configContext.ts';
import { LocationState as ActuatorsLocationState } from 'src/actuators/LocationState';
import { LocationState as ValvesLocationState } from 'src/modules/LocationState';
import { LocationState as SensorsLocationState } from 'src/sensors/LocationState';

export function usePageChange(
    target: (page: number) => string,
    callback: (page: number) => ValvesLocationState | ActuatorsLocationState | SensorsLocationState | null,
) {
    const { rootElement } = useContext(ConfigContext);
    const navigate = useNavigate();
    return useCallback((newPage: number, newSearchParams: URLSearchParams) => {
        rootElement.ownerDocument?.scrollingElement?.scrollTo({ top: 0 });
        const newLocationState = callback(newPage);
        navigate(
            {
                pathname: target(newPage),
                search: newSearchParams.toString(),
            },
            {
                state: newLocationState,
            },
        );
    }, [rootElement, navigate, callback, target]);
}
